import { validateEmailFormat } from '../../../helpers/validators';
import ContatosActionTypes from './actions';

const CONTATO_INICIAL = [];

const ContatosReducer = (state = CONTATO_INICIAL, action) => {
  switch (action.type) {
    case ContatosActionTypes.SET_CONTATOS:
      return action.payload;
    case ContatosActionTypes.ADD_CONTATO:
      if (action.payload) {
        const contatoFound = state.find(cont => cont === action.payload);
        if (!contatoFound && validateEmailFormat(action.payload)) {
          return [...state, action.payload];
        }
      }
      return state;
    case ContatosActionTypes.REMOVE_CONTATO:
      if (action.payload) {
        return state.filter(contato => contato !== action.payload);
      }
      return state;
    case ContatosActionTypes.CLEAR_CONTATOS:
      return CONTATO_INICIAL;
    default:
      return state;
  }
};

export { CONTATO_INICIAL, ContatosReducer };
